export const environment = {
  name: 'DEV',
  production: true,
  dataApiUrl: "https://unapp-api-dev.gigatree.co.uk/api/",
  filePickerApi: {
    key: 'AsY1gpJNSnmbWcp1lIaoQz',
    policy: 'eyJjYWxsIjpbInBpY2siLCJyZWFkIiwid3JpdGUiLCJzdG9yZSIsImNvbnZlcnQiLCJyZW1vdmUiXSwiZXhwaXJ5Ijo3MDk3NDkwMDAwfQ==',
    signature: 'ab1ff63e805fa4efc32ffcf74588d2562f6fded6e09ec20131c9316bfdd72ae7',
    path: '/dev/',
    location: 'azure',
    
  },
  //UnsecureFilePickerApiKey: "AzieLlcz8Q6eSejBAvmXAz",
  userIdle: { idle: 3600, timeout: 5, ping: 0 }
};
